import Vue from 'vue'
const ms = {
  successMessage: (txt) => {
    Vue.notify({
      group: 'all',
      text: txt,
      type: 'success'
    })
  },
  errorMessage: (txt) => {
    Vue.notify({
      group: 'all',
      text: txt,
      type: 'error'
    })
  },
  infoMessage: (txt) => {
    Vue.notify({
      group: 'all',
      text: txt,
      type: 'info'
    })
  }
}

Vue.prototype.$ms = ms
export default ms
